
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexP8StgJOSKzMeta } from "/src/pages/account/index.vue?macro=true";
import { default as _91id_93EqLxRIQgALMeta } from "/src/pages/account/qualifications/[id].vue?macro=true";
import { default as _91id_93RHDnqdgMauMeta } from "/src/pages/admin/accreditations/[id].vue?macro=true";
import { default as indexeKTmKq5TkIMeta } from "/src/pages/admin/accreditations/index.vue?macro=true";
import { default as indexaY6eG7PhNpMeta } from "/src/pages/admin/audit/index.vue?macro=true";
import { default as _91id_93zBo9xQD3FTMeta } from "/src/pages/admin/callsigns/[id].vue?macro=true";
import { default as indexHs3zgkIBn0Meta } from "/src/pages/admin/callsigns/index.vue?macro=true";
import { default as _91id_93Vupc0ak1ylMeta } from "/src/pages/admin/cases/advice/[id].vue?macro=true";
import { default as indexFIeTW0W9PZMeta } from "/src/pages/admin/cases/advice/index.vue?macro=true";
import { default as _91id_93ebn61Jwu7wMeta } from "/src/pages/admin/cases/categories/[id].vue?macro=true";
import { default as indexPA14omFt0hMeta } from "/src/pages/admin/cases/categories/index.vue?macro=true";
import { default as _91id_93Kk4KanY70nMeta } from "/src/pages/admin/cases/categories/sets/[id].vue?macro=true";
import { default as indexly5nL4lZbLMeta } from "/src/pages/admin/cases/categories/sets/index.vue?macro=true";
import { default as _91id_93sL10KSKqMWMeta } from "/src/pages/admin/cases/consumables/[id].vue?macro=true";
import { default as index2r4rxhCmaZMeta } from "/src/pages/admin/cases/consumables/index.vue?macro=true";
import { default as _91id_93goIYoXzMgeMeta } from "/src/pages/admin/cases/drugs/[id].vue?macro=true";
import { default as index5V5WS8A3h5Meta } from "/src/pages/admin/cases/drugs/index.vue?macro=true";
import { default as _91id_930qC1dt0NiNMeta } from "/src/pages/admin/cases/suppliers/[id].vue?macro=true";
import { default as indexeQs1F9jU64Meta } from "/src/pages/admin/cases/suppliers/index.vue?macro=true";
import { default as _91id_93aeQjocuc4VMeta } from "/src/pages/admin/clients/[id].vue?macro=true";
import { default as indexYQKFhSnc4SMeta } from "/src/pages/admin/clients/index.vue?macro=true";
import { default as care_45spacesG5woeehVGlMeta } from "/src/pages/admin/events/[id]/care-spaces.vue?macro=true";
import { default as feedYL2VejxCmWMeta } from "/src/pages/admin/events/[id]/feed.vue?macro=true";
import { default as indexrGU2jfMbSBMeta } from "/src/pages/admin/events/[id]/index.vue?macro=true";
import { default as _91id_93XwWvjND9jPMeta } from "/src/pages/admin/events/bookings/[id].vue?macro=true";
import { default as indexzeeaMUxBlGMeta } from "/src/pages/admin/events/bookings/index.vue?macro=true";
import { default as eoisZMqMVTsSsoMeta } from "/src/pages/admin/events/eois.vue?macro=true";
import { default as indexIPTL4fc0xrMeta } from "/src/pages/admin/events/index.vue?macro=true";
import { default as _91id_93sKjGWlc1G7Meta } from "/src/pages/admin/events/report/[id].vue?macro=true";
import { default as schemaoepcjfsOWdMeta } from "/src/pages/admin/events/schema.ts?macro=true";
import { default as _91id_932zVN2iwTE9Meta } from "/src/pages/admin/events/types/[id].vue?macro=true";
import { default as indexJjWUu4fhS4Meta } from "/src/pages/admin/events/types/index.vue?macro=true";
import { default as _91id_93OYidul8YvIMeta } from "/src/pages/admin/fill-shifts-v2/[id].vue?macro=true";
import { default as indexlJk0jgw8dzMeta } from "/src/pages/admin/fill-shifts-v2/index.vue?macro=true";
import { default as _91id_93AeV06r0sgpMeta } from "/src/pages/admin/fill-shifts/[id].vue?macro=true";
import { default as index46yZusLqosMeta } from "/src/pages/admin/fill-shifts/index.vue?macro=true";
import { default as _91id_93Jow3KOJxfXMeta } from "/src/pages/admin/hospitals/[id].vue?macro=true";
import { default as indexdp5nymc2vIMeta } from "/src/pages/admin/hospitals/index.vue?macro=true";
import { default as indexwK3fSZ6B4uMeta } from "/src/pages/admin/index.vue?macro=true";
import { default as _91id_9340LkxAyT07Meta } from "/src/pages/admin/licensing-requirements/[id].vue?macro=true";
import { default as indexBKueClGFLfMeta } from "/src/pages/admin/licensing-requirements/index.vue?macro=true";
import { default as _91id_9362YfrHFX2eMeta } from "/src/pages/admin/med-registry/medications/[id].vue?macro=true";
import { default as index5zgviXWOxZMeta } from "/src/pages/admin/med-registry/medications/index.vue?macro=true";
import { default as _91id_93IGOPWVV7gOMeta } from "/src/pages/admin/med-registry/registers/[id].vue?macro=true";
import { default as indexmyYqlALsUXMeta } from "/src/pages/admin/med-registry/registers/index.vue?macro=true";
import { default as _91handle_93Jbne3CRbHsMeta } from "/src/pages/admin/organisation/booking-templates/[handle].vue?macro=true";
import { default as index8v3MSRR6ebMeta } from "/src/pages/admin/organisation/booking-templates/index.vue?macro=true";
import { default as typeszaKRb1PjwIMeta } from "/src/pages/admin/organisation/booking-templates/types.ts?macro=true";
import { default as _91handle_93UHxTayhMGJMeta } from "/src/pages/admin/organisation/email-templates/[handle].vue?macro=true";
import { default as index96htj0EbfKMeta } from "/src/pages/admin/organisation/email-templates/index.vue?macro=true";
import { default as typesZi4bxbkQ66Meta } from "/src/pages/admin/organisation/email-templates/types.ts?macro=true";
import { default as _91handle_936ucHWCfrBoMeta } from "/src/pages/admin/organisation/emp-templates/[handle].vue?macro=true";
import { default as indexM3yiVp2viBMeta } from "/src/pages/admin/organisation/emp-templates/index.vue?macro=true";
import { default as typesyEZsNiBRuUMeta } from "/src/pages/admin/organisation/emp-templates/types.ts?macro=true";
import { default as indexrbUdtff3iYMeta } from "/src/pages/admin/organisation/index.vue?macro=true";
import { default as _91handle_93P9K1H0UEvNMeta } from "/src/pages/admin/organisation/report-templates/[handle].vue?macro=true";
import { default as indexrCgQp754FeMeta } from "/src/pages/admin/organisation/report-templates/index.vue?macro=true";
import { default as typescaw08orTgRMeta } from "/src/pages/admin/organisation/report-templates/types.ts?macro=true";
import { default as slackNwEFAy7MLEMeta } from "/src/pages/admin/organisation/slack.vue?macro=true";
import { default as _91handle_93nup9V4QUF9Meta } from "/src/pages/admin/organisation/strings/[handle].vue?macro=true";
import { default as indexghWt18KR66Meta } from "/src/pages/admin/organisation/strings/index.vue?macro=true";
import { default as typesHxIp3IVb1aMeta } from "/src/pages/admin/organisation/strings/types.ts?macro=true";
import { default as _91id_93ijPWKv5RMhMeta } from "/src/pages/admin/qualifications/[id].vue?macro=true";
import { default as _91id_93CWiPb62y63Meta } from "/src/pages/admin/qualifications/documents/[id].vue?macro=true";
import { default as index0XqPNwTDhiMeta } from "/src/pages/admin/qualifications/documents/index.vue?macro=true";
import { default as indexGFG12eSbqxMeta } from "/src/pages/admin/qualifications/index.vue?macro=true";
import { default as _91id_93bth8tHjcOcMeta } from "/src/pages/admin/regions/[id].vue?macro=true";
import { default as indexTRsUWQE4kfMeta } from "/src/pages/admin/regions/index.vue?macro=true";
import { default as _91id_93cJf79TBEopMeta } from "/src/pages/admin/resources/[id].vue?macro=true";
import { default as indexerkL50ZzUZMeta } from "/src/pages/admin/resources/index.vue?macro=true";
import { default as _91id_93Q6oFXO8Q6TMeta } from "/src/pages/admin/sent/emails/[id].vue?macro=true";
import { default as indexF7euWELTLEMeta } from "/src/pages/admin/sent/emails/index.vue?macro=true";
import { default as smsXyEWc8NLcBMeta } from "/src/pages/admin/sent/sms.vue?macro=true";
import { default as _91id_93hwQdFmrAENMeta } from "/src/pages/admin/skillsets/[id].vue?macro=true";
import { default as indexXpkNJhzJVAMeta } from "/src/pages/admin/skillsets/index.vue?macro=true";
import { default as sms_45emailfqXRzWaekYMeta } from "/src/pages/admin/sms-email.vue?macro=true";
import { default as _91id_93lNcYOd58oVMeta } from "/src/pages/admin/telematics/[id].vue?macro=true";
import { default as indexWgx8H2UuJuMeta } from "/src/pages/admin/telematics/index.vue?macro=true";
import { default as _91id_937qaNJmNKrNMeta } from "/src/pages/admin/temp-users/[id].vue?macro=true";
import { default as indexn5s9X7XmyuMeta } from "/src/pages/admin/temp-users/index.vue?macro=true";
import { default as _91id_93EnUtB6saX0Meta } from "/src/pages/admin/templates/[id].vue?macro=true";
import { default as indexMimQN6lvIZMeta } from "/src/pages/admin/templates/index.vue?macro=true";
import { default as _91id_931vb56mPQEFMeta } from "/src/pages/admin/timesheets/[id].vue?macro=true";
import { default as indexEA75LcB0UQMeta } from "/src/pages/admin/timesheets/index.vue?macro=true";
import { default as _91id_938yIAbdCwcUMeta } from "/src/pages/admin/uniform-equipment-items/[id].vue?macro=true";
import { default as indexFGuIdlrFQrMeta } from "/src/pages/admin/uniform-equipment-items/index.vue?macro=true";
import { default as _91id_93fhmgqrJ2l1Meta } from "/src/pages/admin/users/[id].vue?macro=true";
import { default as _91id_93vhV9Uf2akRMeta } from "/src/pages/admin/users/groups/[id].vue?macro=true";
import { default as indexzUtbhd5dnOMeta } from "/src/pages/admin/users/groups/index.vue?macro=true";
import { default as indexcfHL1cVNnBMeta } from "/src/pages/admin/users/index.vue?macro=true";
import { default as indexudNl1q0lgjMeta } from "/src/pages/booking/index.vue?macro=true";
import { default as care_45spacesRybF2DT9HqMeta } from "/src/pages/cad/care-spaces.vue?macro=true";
import { default as dispatchqwRm0VHw61Meta } from "/src/pages/cad/dispatch.vue?macro=true";
import { default as incidentspK17y8zRe2Meta } from "/src/pages/cad/incidents.vue?macro=true";
import { default as telematicscuBsJq8uujMeta } from "/src/pages/cad/telematics.vue?macro=true";
import { default as adviceugFmVc0hMrMeta } from "/src/pages/cases/[id]/advice.vue?macro=true";
import { default as attachmentsETMM44UviJMeta } from "/src/pages/cases/[id]/attachments.vue?macro=true";
import { default as axzxBVjDDOq5Meta } from "/src/pages/cases/[id]/ax.vue?macro=true";
import { default as chief_45complaintHwZcYsq458Meta } from "/src/pages/cases/[id]/chief-complaint.vue?macro=true";
import { default as consumablesewBbt5yFukMeta } from "/src/pages/cases/[id]/consumables.vue?macro=true";
import { default as debugxTLVbWGX0FMeta } from "/src/pages/cases/[id]/debug.vue?macro=true";
import { default as finaliseMklNyDROUoMeta } from "/src/pages/cases/[id]/finalise.vue?macro=true";
import { default as incidentpBXbBk5HBzMeta } from "/src/pages/cases/[id]/incident.vue?macro=true";
import { default as indexyVYi7AF4UuMeta } from "/src/pages/cases/[id]/index.vue?macro=true";
import { default as pmhxzRxZsfbEebMeta } from "/src/pages/cases/[id]/pmhx.vue?macro=true";
import { default as rxNcih4XVhAAMeta } from "/src/pages/cases/[id]/rx.vue?macro=true";
import { default as sketchesLXJlCpnfWNMeta } from "/src/pages/cases/[id]/sketches.vue?macro=true";
import { default as _91id_93UlRT6JYSyHMeta } from "/src/pages/cases/[id].vue?macro=true";
import { default as _91id_93QACm59NrymMeta } from "/src/pages/cases/audit/[id].vue?macro=true";
import { default as indexdLMVElXvIXMeta } from "/src/pages/cases/audit/index.vue?macro=true";
import { default as indexfBYf44eeYfMeta } from "/src/pages/cases/index.vue?macro=true";
import { default as med_45registerAB1ieNx5QfMeta } from "/src/pages/cases/med-register.vue?macro=true";
import { default as minesRmr64FiZfMeta } from "/src/pages/cases/mine.vue?macro=true";
import { default as index9I42Xz23XUMeta } from "/src/pages/cases/open/index.vue?macro=true";
import { default as _91id_93wxISvgqt5AMeta } from "/src/pages/cases/patients/[id].vue?macro=true";
import { default as indexiHGyBODS2QMeta } from "/src/pages/cases/patients/index.vue?macro=true";
import { default as schemafOwjw2F2xFMeta } from "/src/pages/cases/schema.ts?macro=true";
import { default as _91id_93K92x7HsnVwMeta } from "/src/pages/cases/triage/[id].vue?macro=true";
import { default as indexSQcAWjBtFlMeta } from "/src/pages/cases/triage/index.vue?macro=true";
import { default as indexzhYIMAz3QcMeta } from "/src/pages/files/index.vue?macro=true";
import { default as hcEKyTJPuhUjMeta } from "/src/pages/hc.vue?macro=true";
import { default as indexvsa0KwJWqiMeta } from "/src/pages/index.vue?macro=true";
import { default as _91id_93l4Sbe7f5yiMeta } from "/src/pages/live-feed/[id].vue?macro=true";
import { default as indexz0ZORWmtqyMeta } from "/src/pages/login/index.vue?macro=true";
import { default as pin_45loginafuQgYPSGDMeta } from "/src/pages/login/pin-login.vue?macro=true";
import { default as indexbxKFjMa4X7Meta } from "/src/pages/login/reset-password/index.vue?macro=true";
import { default as setQZ2X2e6xFnMeta } from "/src/pages/login/reset-password/set.vue?macro=true";
import { default as set_45passworddj6WrxuQn2Meta } from "/src/pages/login/set-password.vue?macro=true";
import { default as two_45factor_45authOxMThbtCfGMeta } from "/src/pages/login/two-factor-auth.vue?macro=true";
import { default as rapidVB5MoSc1v6Meta } from "/src/pages/rapid.vue?macro=true";
import { default as restock7RJqmm4hxWMeta } from "/src/pages/reports/restock.vue?macro=true";
import { default as eoisHSBJ4K0Sh9Meta } from "/src/pages/shifts/eois.vue?macro=true";
import { default as indexfXHT4DIt1sMeta } from "/src/pages/shifts/index.vue?macro=true";
import { default as upcomingAx51UnyJjpMeta } from "/src/pages/shifts/upcoming.vue?macro=true";
import { default as shiftswH5iLVzUtuMeta } from "/src/pages/shifts.vue?macro=true";
import { default as indexFU3h3UxEg5Meta } from "~/pages/files/index.vue?macro=true";
import { default as _91id_936gdFDMzAufMeta } from "~/pages/account/qualifications/[id].vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    component: () => import("/src/pages/account/index.vue")
  },
  {
    name: "account-qualifications-id",
    path: "/account/qualifications/:id()",
    component: () => import("/src/pages/account/qualifications/[id].vue")
  },
  {
    name: "admin-accreditations-id",
    path: "/admin/accreditations/:id()",
    meta: _91id_93RHDnqdgMauMeta || {},
    component: () => import("/src/pages/admin/accreditations/[id].vue")
  },
  {
    name: "admin-accreditations",
    path: "/admin/accreditations",
    meta: indexeKTmKq5TkIMeta || {},
    component: () => import("/src/pages/admin/accreditations/index.vue")
  },
  {
    name: "admin-audit",
    path: "/admin/audit",
    meta: indexaY6eG7PhNpMeta || {},
    component: () => import("/src/pages/admin/audit/index.vue")
  },
  {
    name: "admin-callsigns-id",
    path: "/admin/callsigns/:id()",
    meta: _91id_93zBo9xQD3FTMeta || {},
    component: () => import("/src/pages/admin/callsigns/[id].vue")
  },
  {
    name: "admin-callsigns",
    path: "/admin/callsigns",
    meta: indexHs3zgkIBn0Meta || {},
    component: () => import("/src/pages/admin/callsigns/index.vue")
  },
  {
    name: "admin-cases-advice-id",
    path: "/admin/cases/advice/:id()",
    meta: _91id_93Vupc0ak1ylMeta || {},
    component: () => import("/src/pages/admin/cases/advice/[id].vue")
  },
  {
    name: "admin-cases-advice",
    path: "/admin/cases/advice",
    meta: indexFIeTW0W9PZMeta || {},
    component: () => import("/src/pages/admin/cases/advice/index.vue")
  },
  {
    name: "admin-cases-categories-id",
    path: "/admin/cases/categories/:id()",
    meta: _91id_93ebn61Jwu7wMeta || {},
    component: () => import("/src/pages/admin/cases/categories/[id].vue")
  },
  {
    name: "admin-cases-categories",
    path: "/admin/cases/categories",
    meta: indexPA14omFt0hMeta || {},
    component: () => import("/src/pages/admin/cases/categories/index.vue")
  },
  {
    name: "admin-cases-categories-sets-id",
    path: "/admin/cases/categories/sets/:id()",
    meta: _91id_93Kk4KanY70nMeta || {},
    component: () => import("/src/pages/admin/cases/categories/sets/[id].vue")
  },
  {
    name: "admin-cases-categories-sets",
    path: "/admin/cases/categories/sets",
    meta: indexly5nL4lZbLMeta || {},
    component: () => import("/src/pages/admin/cases/categories/sets/index.vue")
  },
  {
    name: "admin-cases-consumables-id",
    path: "/admin/cases/consumables/:id()",
    meta: _91id_93sL10KSKqMWMeta || {},
    component: () => import("/src/pages/admin/cases/consumables/[id].vue")
  },
  {
    name: "admin-cases-consumables",
    path: "/admin/cases/consumables",
    meta: index2r4rxhCmaZMeta || {},
    component: () => import("/src/pages/admin/cases/consumables/index.vue")
  },
  {
    name: "admin-cases-drugs-id",
    path: "/admin/cases/drugs/:id()",
    meta: _91id_93goIYoXzMgeMeta || {},
    component: () => import("/src/pages/admin/cases/drugs/[id].vue")
  },
  {
    name: "admin-cases-drugs",
    path: "/admin/cases/drugs",
    meta: index5V5WS8A3h5Meta || {},
    component: () => import("/src/pages/admin/cases/drugs/index.vue")
  },
  {
    name: "admin-cases-suppliers-id",
    path: "/admin/cases/suppliers/:id()",
    meta: _91id_930qC1dt0NiNMeta || {},
    component: () => import("/src/pages/admin/cases/suppliers/[id].vue")
  },
  {
    name: "admin-cases-suppliers",
    path: "/admin/cases/suppliers",
    meta: indexeQs1F9jU64Meta || {},
    component: () => import("/src/pages/admin/cases/suppliers/index.vue")
  },
  {
    name: "admin-clients-id",
    path: "/admin/clients/:id()",
    meta: _91id_93aeQjocuc4VMeta || {},
    component: () => import("/src/pages/admin/clients/[id].vue")
  },
  {
    name: "admin-clients",
    path: "/admin/clients",
    meta: indexYQKFhSnc4SMeta || {},
    component: () => import("/src/pages/admin/clients/index.vue")
  },
  {
    name: "admin-events-id-care-spaces",
    path: "/admin/events/:id()/care-spaces",
    meta: care_45spacesG5woeehVGlMeta || {},
    component: () => import("/src/pages/admin/events/[id]/care-spaces.vue")
  },
  {
    name: "admin-events-id-feed",
    path: "/admin/events/:id()/feed",
    meta: feedYL2VejxCmWMeta || {},
    component: () => import("/src/pages/admin/events/[id]/feed.vue")
  },
  {
    name: "admin-events-id",
    path: "/admin/events/:id()",
    meta: indexrGU2jfMbSBMeta || {},
    component: () => import("/src/pages/admin/events/[id]/index.vue")
  },
  {
    name: "admin-events-bookings-id",
    path: "/admin/events/bookings/:id()",
    component: () => import("/src/pages/admin/events/bookings/[id].vue")
  },
  {
    name: "admin-events-bookings",
    path: "/admin/events/bookings",
    meta: indexzeeaMUxBlGMeta || {},
    component: () => import("/src/pages/admin/events/bookings/index.vue")
  },
  {
    name: "admin-events-eois",
    path: "/admin/events/eois",
    meta: eoisZMqMVTsSsoMeta || {},
    component: () => import("/src/pages/admin/events/eois.vue")
  },
  {
    name: "admin-events",
    path: "/admin/events",
    meta: indexIPTL4fc0xrMeta || {},
    component: () => import("/src/pages/admin/events/index.vue")
  },
  {
    name: "admin-events-report-id",
    path: "/admin/events/report/:id()",
    meta: _91id_93sKjGWlc1G7Meta || {},
    component: () => import("/src/pages/admin/events/report/[id].vue")
  },
  {
    name: "admin-events-schema",
    path: "/admin/events/schema",
    component: () => import("/src/pages/admin/events/schema.ts")
  },
  {
    name: "admin-events-types-id",
    path: "/admin/events/types/:id()",
    meta: _91id_932zVN2iwTE9Meta || {},
    component: () => import("/src/pages/admin/events/types/[id].vue")
  },
  {
    name: "admin-events-types",
    path: "/admin/events/types",
    meta: indexJjWUu4fhS4Meta || {},
    component: () => import("/src/pages/admin/events/types/index.vue")
  },
  {
    name: "admin-fill-shifts-v2-id",
    path: "/admin/fill-shifts-v2/:id()",
    meta: _91id_93OYidul8YvIMeta || {},
    component: () => import("/src/pages/admin/fill-shifts-v2/[id].vue")
  },
  {
    name: "admin-fill-shifts-v2",
    path: "/admin/fill-shifts-v2",
    meta: indexlJk0jgw8dzMeta || {},
    component: () => import("/src/pages/admin/fill-shifts-v2/index.vue")
  },
  {
    name: "admin-fill-shifts-id",
    path: "/admin/fill-shifts/:id()",
    meta: _91id_93AeV06r0sgpMeta || {},
    component: () => import("/src/pages/admin/fill-shifts/[id].vue")
  },
  {
    name: "admin-fill-shifts",
    path: "/admin/fill-shifts",
    meta: index46yZusLqosMeta || {},
    component: () => import("/src/pages/admin/fill-shifts/index.vue")
  },
  {
    name: "admin-hospitals-id",
    path: "/admin/hospitals/:id()",
    meta: _91id_93Jow3KOJxfXMeta || {},
    component: () => import("/src/pages/admin/hospitals/[id].vue")
  },
  {
    name: "admin-hospitals",
    path: "/admin/hospitals",
    meta: indexdp5nymc2vIMeta || {},
    component: () => import("/src/pages/admin/hospitals/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/src/pages/admin/index.vue")
  },
  {
    name: "admin-licensing-requirements-id",
    path: "/admin/licensing-requirements/:id()",
    meta: _91id_9340LkxAyT07Meta || {},
    component: () => import("/src/pages/admin/licensing-requirements/[id].vue")
  },
  {
    name: "admin-licensing-requirements",
    path: "/admin/licensing-requirements",
    meta: indexBKueClGFLfMeta || {},
    component: () => import("/src/pages/admin/licensing-requirements/index.vue")
  },
  {
    name: "admin-med-registry-medications-id",
    path: "/admin/med-registry/medications/:id()",
    meta: _91id_9362YfrHFX2eMeta || {},
    component: () => import("/src/pages/admin/med-registry/medications/[id].vue")
  },
  {
    name: "admin-med-registry-medications",
    path: "/admin/med-registry/medications",
    meta: index5zgviXWOxZMeta || {},
    component: () => import("/src/pages/admin/med-registry/medications/index.vue")
  },
  {
    name: "admin-med-registry-registers-id",
    path: "/admin/med-registry/registers/:id()",
    meta: _91id_93IGOPWVV7gOMeta || {},
    component: () => import("/src/pages/admin/med-registry/registers/[id].vue")
  },
  {
    name: "admin-med-registry-registers",
    path: "/admin/med-registry/registers",
    meta: indexmyYqlALsUXMeta || {},
    component: () => import("/src/pages/admin/med-registry/registers/index.vue")
  },
  {
    name: "admin-organisation-booking-templates-handle",
    path: "/admin/organisation/booking-templates/:handle()",
    component: () => import("/src/pages/admin/organisation/booking-templates/[handle].vue")
  },
  {
    name: "admin-organisation-booking-templates",
    path: "/admin/organisation/booking-templates",
    component: () => import("/src/pages/admin/organisation/booking-templates/index.vue")
  },
  {
    name: "admin-organisation-booking-templates-types",
    path: "/admin/organisation/booking-templates/types",
    component: () => import("/src/pages/admin/organisation/booking-templates/types.ts")
  },
  {
    name: "admin-organisation-email-templates-handle",
    path: "/admin/organisation/email-templates/:handle()",
    component: () => import("/src/pages/admin/organisation/email-templates/[handle].vue")
  },
  {
    name: "admin-organisation-email-templates",
    path: "/admin/organisation/email-templates",
    component: () => import("/src/pages/admin/organisation/email-templates/index.vue")
  },
  {
    name: "admin-organisation-email-templates-types",
    path: "/admin/organisation/email-templates/types",
    component: () => import("/src/pages/admin/organisation/email-templates/types.ts")
  },
  {
    name: "admin-organisation-emp-templates-handle",
    path: "/admin/organisation/emp-templates/:handle()",
    component: () => import("/src/pages/admin/organisation/emp-templates/[handle].vue")
  },
  {
    name: "admin-organisation-emp-templates",
    path: "/admin/organisation/emp-templates",
    component: () => import("/src/pages/admin/organisation/emp-templates/index.vue")
  },
  {
    name: "admin-organisation-emp-templates-types",
    path: "/admin/organisation/emp-templates/types",
    component: () => import("/src/pages/admin/organisation/emp-templates/types.ts")
  },
  {
    name: "admin-organisation",
    path: "/admin/organisation",
    meta: indexrbUdtff3iYMeta || {},
    component: () => import("/src/pages/admin/organisation/index.vue")
  },
  {
    name: "admin-organisation-report-templates-handle",
    path: "/admin/organisation/report-templates/:handle()",
    component: () => import("/src/pages/admin/organisation/report-templates/[handle].vue")
  },
  {
    name: "admin-organisation-report-templates",
    path: "/admin/organisation/report-templates",
    component: () => import("/src/pages/admin/organisation/report-templates/index.vue")
  },
  {
    name: "admin-organisation-report-templates-types",
    path: "/admin/organisation/report-templates/types",
    component: () => import("/src/pages/admin/organisation/report-templates/types.ts")
  },
  {
    name: "admin-organisation-slack",
    path: "/admin/organisation/slack",
    component: () => import("/src/pages/admin/organisation/slack.vue")
  },
  {
    name: "admin-organisation-strings-handle",
    path: "/admin/organisation/strings/:handle()",
    component: () => import("/src/pages/admin/organisation/strings/[handle].vue")
  },
  {
    name: "admin-organisation-strings",
    path: "/admin/organisation/strings",
    component: () => import("/src/pages/admin/organisation/strings/index.vue")
  },
  {
    name: "admin-organisation-strings-types",
    path: "/admin/organisation/strings/types",
    component: () => import("/src/pages/admin/organisation/strings/types.ts")
  },
  {
    name: "admin-qualifications-id",
    path: "/admin/qualifications/:id()",
    meta: _91id_93ijPWKv5RMhMeta || {},
    component: () => import("/src/pages/admin/qualifications/[id].vue")
  },
  {
    name: "admin-qualifications-documents-id",
    path: "/admin/qualifications/documents/:id()",
    component: () => import("/src/pages/admin/qualifications/documents/[id].vue")
  },
  {
    name: "admin-qualifications-documents",
    path: "/admin/qualifications/documents",
    meta: index0XqPNwTDhiMeta || {},
    component: () => import("/src/pages/admin/qualifications/documents/index.vue")
  },
  {
    name: "admin-qualifications",
    path: "/admin/qualifications",
    meta: indexGFG12eSbqxMeta || {},
    component: () => import("/src/pages/admin/qualifications/index.vue")
  },
  {
    name: "admin-regions-id",
    path: "/admin/regions/:id()",
    meta: _91id_93bth8tHjcOcMeta || {},
    component: () => import("/src/pages/admin/regions/[id].vue")
  },
  {
    name: "admin-regions",
    path: "/admin/regions",
    meta: indexTRsUWQE4kfMeta || {},
    component: () => import("/src/pages/admin/regions/index.vue")
  },
  {
    name: "admin-resources-id",
    path: "/admin/resources/:id()",
    meta: _91id_93cJf79TBEopMeta || {},
    component: () => import("/src/pages/admin/resources/[id].vue")
  },
  {
    name: "admin-resources",
    path: "/admin/resources",
    meta: indexerkL50ZzUZMeta || {},
    component: () => import("/src/pages/admin/resources/index.vue")
  },
  {
    name: "admin-sent-emails-id",
    path: "/admin/sent/emails/:id()",
    component: () => import("/src/pages/admin/sent/emails/[id].vue")
  },
  {
    name: "admin-sent-emails",
    path: "/admin/sent/emails",
    meta: indexF7euWELTLEMeta || {},
    component: () => import("/src/pages/admin/sent/emails/index.vue")
  },
  {
    name: "admin-sent-sms",
    path: "/admin/sent/sms",
    meta: smsXyEWc8NLcBMeta || {},
    component: () => import("/src/pages/admin/sent/sms.vue")
  },
  {
    name: "admin-skillsets-id",
    path: "/admin/skillsets/:id()",
    meta: _91id_93hwQdFmrAENMeta || {},
    component: () => import("/src/pages/admin/skillsets/[id].vue")
  },
  {
    name: "admin-skillsets",
    path: "/admin/skillsets",
    meta: indexXpkNJhzJVAMeta || {},
    component: () => import("/src/pages/admin/skillsets/index.vue")
  },
  {
    name: "admin-sms-email",
    path: "/admin/sms-email",
    meta: sms_45emailfqXRzWaekYMeta || {},
    component: () => import("/src/pages/admin/sms-email.vue")
  },
  {
    name: "admin-telematics-id",
    path: "/admin/telematics/:id()",
    meta: _91id_93lNcYOd58oVMeta || {},
    component: () => import("/src/pages/admin/telematics/[id].vue")
  },
  {
    name: "admin-telematics",
    path: "/admin/telematics",
    meta: indexWgx8H2UuJuMeta || {},
    component: () => import("/src/pages/admin/telematics/index.vue")
  },
  {
    name: "admin-temp-users-id",
    path: "/admin/temp-users/:id()",
    meta: _91id_937qaNJmNKrNMeta || {},
    component: () => import("/src/pages/admin/temp-users/[id].vue")
  },
  {
    name: "admin-temp-users",
    path: "/admin/temp-users",
    meta: indexn5s9X7XmyuMeta || {},
    component: () => import("/src/pages/admin/temp-users/index.vue")
  },
  {
    name: "admin-templates-id",
    path: "/admin/templates/:id()",
    meta: _91id_93EnUtB6saX0Meta || {},
    component: () => import("/src/pages/admin/templates/[id].vue")
  },
  {
    name: "admin-templates",
    path: "/admin/templates",
    meta: indexMimQN6lvIZMeta || {},
    component: () => import("/src/pages/admin/templates/index.vue")
  },
  {
    name: "admin-timesheets-id",
    path: "/admin/timesheets/:id()",
    meta: _91id_931vb56mPQEFMeta || {},
    component: () => import("/src/pages/admin/timesheets/[id].vue")
  },
  {
    name: "admin-timesheets",
    path: "/admin/timesheets",
    meta: indexEA75LcB0UQMeta || {},
    component: () => import("/src/pages/admin/timesheets/index.vue")
  },
  {
    name: "admin-uniform-equipment-items-id",
    path: "/admin/uniform-equipment-items/:id()",
    meta: _91id_938yIAbdCwcUMeta || {},
    component: () => import("/src/pages/admin/uniform-equipment-items/[id].vue")
  },
  {
    name: "admin-uniform-equipment-items",
    path: "/admin/uniform-equipment-items",
    meta: indexFGuIdlrFQrMeta || {},
    component: () => import("/src/pages/admin/uniform-equipment-items/index.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: _91id_93fhmgqrJ2l1Meta || {},
    component: () => import("/src/pages/admin/users/[id].vue")
  },
  {
    name: "admin-users-groups-id",
    path: "/admin/users/groups/:id()",
    meta: _91id_93vhV9Uf2akRMeta || {},
    component: () => import("/src/pages/admin/users/groups/[id].vue")
  },
  {
    name: "admin-users-groups",
    path: "/admin/users/groups",
    meta: indexzUtbhd5dnOMeta || {},
    component: () => import("/src/pages/admin/users/groups/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: indexcfHL1cVNnBMeta || {},
    component: () => import("/src/pages/admin/users/index.vue")
  },
  {
    name: "booking",
    path: "/booking",
    meta: indexudNl1q0lgjMeta || {},
    component: () => import("/src/pages/booking/index.vue")
  },
  {
    name: "cad-care-spaces",
    path: "/cad/care-spaces",
    meta: care_45spacesRybF2DT9HqMeta || {},
    component: () => import("/src/pages/cad/care-spaces.vue")
  },
  {
    name: "cad-dispatch",
    path: "/cad/dispatch",
    meta: dispatchqwRm0VHw61Meta || {},
    component: () => import("/src/pages/cad/dispatch.vue")
  },
  {
    name: "cad-incidents",
    path: "/cad/incidents",
    meta: incidentspK17y8zRe2Meta || {},
    component: () => import("/src/pages/cad/incidents.vue")
  },
  {
    name: "cad-telematics",
    path: "/cad/telematics",
    component: () => import("/src/pages/cad/telematics.vue")
  },
  {
    name: _91id_93UlRT6JYSyHMeta?.name,
    path: "/cases/:id()",
    meta: _91id_93UlRT6JYSyHMeta || {},
    component: () => import("/src/pages/cases/[id].vue"),
    children: [
  {
    name: "cases-id-advice",
    path: "advice",
    component: () => import("/src/pages/cases/[id]/advice.vue")
  },
  {
    name: "cases-id-attachments",
    path: "attachments",
    component: () => import("/src/pages/cases/[id]/attachments.vue")
  },
  {
    name: "cases-id-ax",
    path: "ax",
    component: () => import("/src/pages/cases/[id]/ax.vue")
  },
  {
    name: "cases-id-chief-complaint",
    path: "chief-complaint",
    component: () => import("/src/pages/cases/[id]/chief-complaint.vue")
  },
  {
    name: "cases-id-consumables",
    path: "consumables",
    component: () => import("/src/pages/cases/[id]/consumables.vue")
  },
  {
    name: "cases-id-debug",
    path: "debug",
    component: () => import("/src/pages/cases/[id]/debug.vue")
  },
  {
    name: "cases-id-finalise",
    path: "finalise",
    component: () => import("/src/pages/cases/[id]/finalise.vue")
  },
  {
    name: "cases-id-incident",
    path: "incident",
    component: () => import("/src/pages/cases/[id]/incident.vue")
  },
  {
    name: "cases-id",
    path: "",
    component: () => import("/src/pages/cases/[id]/index.vue")
  },
  {
    name: "cases-id-pmhx",
    path: "pmhx",
    component: () => import("/src/pages/cases/[id]/pmhx.vue")
  },
  {
    name: "cases-id-rx",
    path: "rx",
    component: () => import("/src/pages/cases/[id]/rx.vue")
  },
  {
    name: "cases-id-sketches",
    path: "sketches",
    component: () => import("/src/pages/cases/[id]/sketches.vue")
  }
]
  },
  {
    name: "cases-audit-id",
    path: "/cases/audit/:id()",
    component: () => import("/src/pages/cases/audit/[id].vue")
  },
  {
    name: "cases-audit",
    path: "/cases/audit",
    meta: indexdLMVElXvIXMeta || {},
    component: () => import("/src/pages/cases/audit/index.vue")
  },
  {
    name: "cases",
    path: "/cases",
    meta: indexfBYf44eeYfMeta || {},
    component: () => import("/src/pages/cases/index.vue")
  },
  {
    name: "cases-med-register",
    path: "/cases/med-register",
    meta: med_45registerAB1ieNx5QfMeta || {},
    component: () => import("/src/pages/cases/med-register.vue")
  },
  {
    name: "cases-mine",
    path: "/cases/mine",
    component: () => import("/src/pages/cases/mine.vue")
  },
  {
    name: "cases-open",
    path: "/cases/open",
    meta: index9I42Xz23XUMeta || {},
    component: () => import("/src/pages/cases/open/index.vue")
  },
  {
    name: "cases-patients-id",
    path: "/cases/patients/:id()",
    meta: _91id_93wxISvgqt5AMeta || {},
    component: () => import("/src/pages/cases/patients/[id].vue")
  },
  {
    name: "cases-patients",
    path: "/cases/patients",
    meta: indexiHGyBODS2QMeta || {},
    component: () => import("/src/pages/cases/patients/index.vue")
  },
  {
    name: "cases-schema",
    path: "/cases/schema",
    component: () => import("/src/pages/cases/schema.ts")
  },
  {
    name: "cases-triage-id",
    path: "/cases/triage/:id()",
    meta: _91id_93K92x7HsnVwMeta || {},
    component: () => import("/src/pages/cases/triage/[id].vue")
  },
  {
    name: "cases-triage",
    path: "/cases/triage",
    meta: indexSQcAWjBtFlMeta || {},
    component: () => import("/src/pages/cases/triage/index.vue")
  },
  {
    name: "files",
    path: "/files",
    component: () => import("/src/pages/files/index.vue")
  },
  {
    name: "hc",
    path: "/hc",
    meta: hcEKyTJPuhUjMeta || {},
    component: () => import("/src/pages/hc.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "live-feed-id",
    path: "/live-feed/:id()",
    meta: _91id_93l4Sbe7f5yiMeta || {},
    component: () => import("/src/pages/live-feed/[id].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexz0ZORWmtqyMeta || {},
    component: () => import("/src/pages/login/index.vue")
  },
  {
    name: "login-pin-login",
    path: "/login/pin-login",
    meta: pin_45loginafuQgYPSGDMeta || {},
    component: () => import("/src/pages/login/pin-login.vue")
  },
  {
    name: "login-reset-password",
    path: "/login/reset-password",
    meta: indexbxKFjMa4X7Meta || {},
    component: () => import("/src/pages/login/reset-password/index.vue")
  },
  {
    name: "login-reset-password-set",
    path: "/login/reset-password/set",
    meta: setQZ2X2e6xFnMeta || {},
    component: () => import("/src/pages/login/reset-password/set.vue")
  },
  {
    name: "login-set-password",
    path: "/login/set-password",
    meta: set_45passworddj6WrxuQn2Meta || {},
    component: () => import("/src/pages/login/set-password.vue")
  },
  {
    name: "login-two-factor-auth",
    path: "/login/two-factor-auth",
    meta: two_45factor_45authOxMThbtCfGMeta || {},
    component: () => import("/src/pages/login/two-factor-auth.vue")
  },
  {
    name: "rapid",
    path: "/rapid",
    meta: rapidVB5MoSc1v6Meta || {},
    component: () => import("/src/pages/rapid.vue")
  },
  {
    name: "reports-restock",
    path: "/reports/restock",
    component: () => import("/src/pages/reports/restock.vue")
  },
  {
    name: shiftswH5iLVzUtuMeta?.name,
    path: "/shifts",
    meta: shiftswH5iLVzUtuMeta || {},
    component: () => import("/src/pages/shifts.vue"),
    children: [
  {
    name: "shifts-eois",
    path: "eois",
    component: () => import("/src/pages/shifts/eois.vue")
  },
  {
    name: "shifts",
    path: "",
    component: () => import("/src/pages/shifts/index.vue")
  },
  {
    name: "shifts-upcoming",
    path: "upcoming",
    component: () => import("/src/pages/shifts/upcoming.vue")
  }
]
  },
  {
    name: "files-folder",
    path: "/files/:id",
    component: () => import("~/pages/files/index.vue")
  },
  {
    name: "admin-qualifications-document-edit",
    path: "/admin/qualifications/documents/:id/edit",
    component: () => import("~/pages/account/qualifications/[id].vue")
  }
]